<template>
  <button class="btn btn-outline-secondary" @click="goBack()"><font-awesome-icon icon="chevron-left" /> Zurück</button>

  <div v-if="signatur == null" class="alert alert-danger mt-5">Ungültige Signatur ID: {{ signaturid }}</div>

  <div v-else>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="fs-2 mb-0">{{ signatur.unterschrift }}</h1>
      </div>

      <router-link v-if="store.getters.isAdmin" :to="{ name: 'EditSignatur', query: { signaturid: signaturid } }" class="btn">
        <font-awesome-icon icon="pen" />
      </router-link>
    </div>

    <div class="row mx-0">
      <div class="col-4 p-2 ps-0">
        <div class="bg-white shadow rounded p-3 pe-4 h-100">
          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Zeichnung:</div>

            <div class="col p-0">{{ signatur.zeichnung }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Funktion:</div>

            <div class="col p-0">{{ signatur.funktion }}</div>
          </div>

          <div class="row mx-0 mb-2">
            <div class="col-4 p-0 fw-bold">Funktion EN:</div>

            <div class="col p-0">{{ signatur.funktionEN }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, PropType } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  import { Signatur } from '@/models/VertragspartnerModels';
  //#endregion

  const props = defineProps({
    signaturid: {
      type: String as PropType<string>,
      required: true,
    },
  });

  const store = useStore();
  const router = useRouter();

  const signatur = computed(() => store.getters.signaturen.find((v: Signatur) => v.id == parseInt(props.signaturid)));

  function goBack() {
    router.push({ name: 'Signaturen' });
  }
</script>
